import { useState, useEffect } from 'react';
import TradingViewChart, { TradingViewChartProps } from './index';

/**
 * Temporary solution to avoid chart crash
 * @param props
 */
const RemountOnExchangeChanging = (props: TradingViewChartProps) => {
  const [compact, setCompact] = useState(props.compact);
  const [exchange, setExchange] = useState(props.exchange);
  const [pair, setPair] = useState(props.pair);
  const [address, set_address] = useState(props.address);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (props.exchange !== exchange || props.pair !== pair || props.address !== address) {
      setLoading(true);
    }
    if (props.compact !== compact) {
      setLoading(true);
    }
    if (props.pair !== pair || props.address !== address) {
      setPair(props.pair);
      set_address(props.address);
    }
    setExchange(props.exchange);
    setCompact(props.compact);
  }, [
    props.exchange, props.compact, exchange, compact, props.pair, props.address, pair, address
  ]);

  useEffect(() => {
    if (loading) {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  }, [loading]);

  if (loading) {
    return <div />;
  }
  return <TradingViewChart {...props} />;
};

export default RemountOnExchangeChanging;